import { lazy } from 'react';

const SafeDealSuccessPage = lazy(() =>
  import(/* webpackChunkName: "safe-deal-success" */ './SafeDealSuccessPage'),
);

export default SafeDealSuccessPage;
